import Header from './Header';
import Hero from './Hero';
import About from './About';
import Skills from './Skills';
import WorkExperience from './WorkExperience';
import Projects from './Projects';
import Education from './Education';
import Personal from './Personal';
import Contact from './Contact';

function Home() {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Skills />
      <Projects />
      <WorkExperience />
      <Education />
      <Personal />
      <Contact />
    </>
  );
}

export default Home;
